import { configureStore } from "@reduxjs/toolkit"
import renewalAndEmailSlice from "./renewalAndEmailSlice"
import userSlice from "./userSlice"
import enumSlice from "./enumSlice"
import applicationSlice from "./applicationSlice"
import agencySlice from "./agencySlice"
import contactSlice from "./contactSlice"
import authenticationSlice from "./authenticationSlice"
import notificationSlice from "./notificationSlice"
import endorsementSlice from "./endorsementSlice"

const store = configureStore({
    reducer: {
        renewalAndEmail: renewalAndEmailSlice.reducer,
        user: userSlice.reducer,
        enums: enumSlice.reducer,
        application: applicationSlice.reducer,
        agency: agencySlice.reducer,
        contact: contactSlice.reducer,
        authentication: authenticationSlice.reducer,
        notification: notificationSlice.reducer,
        endorsement: endorsementSlice.reducer
    }
})

export default store
